/** @jsx h */
import { h, Component } from 'preact'
import ClipboardJS from 'clipboard'

import navigatorShare from '../../../utils/navigatorShare'
import snackbarShow from '../../../utils/snackbar'
import Snackbar from '../ui/Snackbar'
import t from '../../../utils/translate'

const snackbarId = 'Snackbar--JourneyCopy'

const makeCopyLink = () => {
  snackbarShow(snackbarId)
}

class JourneyShare extends Component {
  componentDidMount () {
    const copyBtn = document.getElementById('JourneyShare--copy')
    if (copyBtn) {
      this.clipboard = new ClipboardJS(copyBtn)
    }
  }

  share (text) {
    const { href, title } = this.props
    navigatorShare(href, title, text)
  }

  render () {
    const { href, title, organization, shareImage } = this.props

    const text = t('journeys.js.share.button', {
      title,
      organizationName: organization.name
    })
    const twitterParams = {
      text,
      url: href,
      via: 'ProvenanceHQ'
    }
    const encodedParams = jQuery.param(twitterParams)

    const pinParams = {
      url: href,
      description: text,
      media: shareImage
    }
    const pinEncodedParams = jQuery.param(pinParams)

    const facebookLink = `https://www.facebook.com/sharer/sharer.php?u=${href}`
    const twitterLink = `https://twitter.com/intent/tweet?${encodedParams}`
    const pinterestLink = `https://www.pinterest.com/pin/create/link/?${pinEncodedParams}`

    let shareButton = null
    if (navigator.share) {
      shareButton = (
        <button
          class='Action Action--backgroundIcon Action-backgroundIconShare Action-social'
          onClick={() => {
            this.share(text)
          }}
          type='button'
        >
          Share
        </button>
      )
    } else {
      shareButton = (
        <button
          class='Action Action--backgroundIcon Action-backgroundIconCopy Action-social'
          data-clipboard-text={href}
          onClick={() => {
            makeCopyLink()
          }}
          id='JourneyShare--copy'
          type='button'
        >
          Copy
        </button>
      )
    }

    return (
      <div class='Journey-share'>
        <p class='BodyUI--emphasis'>{t('journeys.js.share.intro')}</p>
        <div class='SocialShare-list SocialShare-list--compact'>
          <ul class='SocialShare-listInner'>
            <li class='SocialShare-item'>{shareButton}</li>
            <li class='SocialShare-item'>
              <a
                class='Action Action-newTab Action--backgroundIcon Action--twitter Action--backgroundIconTwitter Action-social'
                href={twitterLink}
                target='_blank'
                rel='noopener noreferrer'
                title={t('journeys.js.share.twitter')}
              >
                {t('journeys.js.share.twitter')}
              </a>
            </li>
            <li class='SocialShare-item'>
              <a
                class='Action Action-newTab Action--backgroundIcon Action--pinterest Action--backgroundIconPinterest Action-social'
                href={pinterestLink}
                rel='noopener noreferrer'
                target='_blank'
                title={t('journeys.js.share.pinterest')}
              >
                {t('journeys.js.share.pinterest')}
              </a>
            </li>
            <li class='SocialShare-item'>
              <a
                class='Action Action-newTab Action--backgroundIcon Action--facebook Action--backgroundIconFacebook Action-social'
                href={facebookLink}
                rel='noopener noreferrer'
                target='_blank'
                title={t('journeys.js.share.facebook')}
              >
                {t('journeys.js.share.facebook')}
              </a>
            </li>
          </ul>
          <Snackbar
            id={snackbarId}
            message={t('journeys.js.share.copied_clipboard')}
          />
        </div>
      </div>
    )
  }
}

export default JourneyShare
